import { Model } from '@vuex-orm/core';
import { MR } from '../MaintenanceRecord';
import { Technician } from '../Technician';
import Part from '../Part/Part';
import { PartInterface } from '../Part/Part';
import { TechnicianInterface } from '../Technician/Technician';

export interface PartRequestInterface {
  id: number;
  tech_id?: number;
  mr_id?: number;
  task_id?: number;
  job_id?: number;
  part_id?: number;
  created_at?: string;
  updated_at?: string;
  tech_name?: string;
  jobNumber?: string;
  taskNumber?: string;
  quantity?: number;
  fulfilled?: number;
  ordered?: number;

  part?: PartInterface;
  technician?: TechnicianInterface;
}

export class PartRequest extends Model implements PartRequestInterface {
  id!: number;
  tech_id?: number;
  mr_id?: number;
  task_id?: number;
  job_id?: number;
  part_id?: number;
  created_at?: string;
  updated_at?: string;
  tech_name?: string;
  jobNumber?: string;
  taskNumber?: string;
  quantity?: number;
  fulfilled?: number;
  ordered?: number;
  part?: PartInterface;
  technician?: TechnicianInterface

  static entity = 'partRequest';
  static primaryKey = 'id'

  static state() {
    return {
      total: 0,
      fetching: false,
      error: []
    }
  }

  static fields() {
    return {
      id: this.attr(null),
      created_at: this.string(null).nullable(),
      updated_at: this.string(null).nullable(),
      tech_name: this.string(null).nullable(),
      jobNumber: this.string(null).nullable(),
      taskNumber: this.string(null).nullable(),
      mr_id: this.number(null).nullable(),
      tech_id: this.number(null).nullable(),
      task_id: this.number(null).nullable(),
      job_id: this.number(null).nullable(),
      part_id: this.number(null).nullable(),
      quantity: this.number(null).nullable(),
      fulfilled: this.number(0).nullable(),
      ordered: this.number(0).nullable(),

      mr: this.belongsTo(MR, 'mr_id', 'id'),
      technician: this.belongsTo(Technician, 'tech_id', 'ID'),
      part: this.belongsTo(Part, 'part_id', 'id')
    }
  }

  static isSaving() {
    return this.store().state.entities[this.entity].saving;
  }

  static getErrors() {
    return this.store().state.entities[this.entity].error;
  }
}

export default PartRequest;